import { UseFormReturn } from 'react-hook-form';
import { useCustomMutation } from '@hooks/useCustomMutation';
import { createCustomer } from '@/services/customers';

type ValueLabel = {
  label: string;
  value: string;
};
export type CustomerForm = {
  name: string;
  email: string;
  identification_number: number;
  phone: string;
  address: string;
  type_document_identification_id: any;
  type_organization_id: any;
  municipality_id: any;
  type_regime_id: any;
};

export const useCreateCustomerForm = (methods: UseFormReturn<CustomerForm, any, undefined>, callbackSuccess : any) => {
  const { handleSubmit, formState } = methods;
  const { mutateAsync } = useCustomMutation(['customers', 'created'], createCustomer, {callbackSuccess});
  const onSubmit = async (data: CustomerForm) => {
    const {
      type_document_identification_id,
      type_regime_id,
      type_organization_id,
      municipality_id,
      identification_number,
      ...rest
    } = data;
    await mutateAsync({
      ...rest,
      identification_number: Number(identification_number),
      type_document_identification_id,
      type_regime_id,
      type_organization_id,
      municipality_id,
    });
  };
  return {
    submit: handleSubmit(onSubmit),
    isValid: formState.isValid,
    isSubmitting: formState.isSubmitting,
  };
};
